import { SCENARIO_EP } from "utils/constants/coreConstants";
import { PC } from "utils/constants/descriptorTypes";


//TODO Filtrar substâncias perigosas no produto

export default (product, typesOfProducts, lcsUse, scenarios, shipmentsById, rawMaterialsById) => {

    const dangerousSubstancesIds = product.Produto_Mps.filter(s => s.contribui_perigo).map(s => s.id_mp.id);

    // Filtra cenários CEDEMP
    const filteredScenariosLists = [];

    dangerousSubstancesIds.forEach(dsID => {
        filteredScenariosLists.push(
            scenarios.filter(sc =>
                sc.tipo === SCENARIO_EP &&
                dangerousSubstancesIds.includes(sc.id_substancia) &&
                sc.id_substancia_fornecedor &&
                lcsUse.id === parseInt(sc.id_lcs) &&
                (
                    dsID === shipmentsById[sc.id_substancia_fornecedor].id_mp ||
                    rawMaterialsById[dsID].inter_misturas
                        .map(mix => mix.id_mistura)
                        .includes(shipmentsById[sc.id_substancia_fornecedor].id_mp)
                )
            )
        );
    });

    let flatFilteredScenarios = [];

    filteredScenariosLists.forEach(scenarioList => {
        const relevantScenarios = scenarioList.filter( sc => (
            sc.descritores.length > 0  && sc.descritores.some(dsc => (dsc.id_tipo === PC && typesOfProducts.includes(dsc.codigo)))
        ));
        flatFilteredScenarios = flatFilteredScenarios.concat(relevantScenarios);
    });

    return flatFilteredScenarios;
};



